import style from "./spinner.module.scss";

const Spinner = () => {
  return <div className={style.spinner} />;
};

export default Spinner;
